module.exports = __webpack_public_path__ + "739e40b55610eae0e2da5aba4332a1e7.svg";